<template>
    <div>
        <GuestStudentLayout>
            <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                <ValidationObserver ref="loginForm">
                    <div class="row">
                        <div class="col-12 mt-4">
                            <ValidationProvider name="national_id" :rules="!loginForm.passport_number ? 'required|digits:11' : ''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('tc_no')">
                                    <b-form-input
                                        v-model="loginForm.national_id"
                                        v-mask="'###########'"
                                        :disabled="!!loginForm.passport_number"
                                        :state="errors[0] ? false : (valid ? true : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12">
                            <ValidationProvider name="passport_number" :rules="!loginForm.national_id ? 'required|max:255' : ''" v-slot="{valid, errors}">
                                <b-form-group :label="$t('passport_number')">
                                    <b-form-input
                                        v-model="loginForm.passport_number"
                                        :disabled="!!loginForm.national_id"
                                        :state="errors[0] ? false : (valid ? true : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12">
                            <ValidationProvider name="pin" rules="required|digits:6" v-slot="{valid, errors}">
                                <b-form-group :label="$t('pin_code')" class="input-icon position-relative">
                                    <b-form-input
                                        :type="showPin ? 'text' : 'password'"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        v-model="loginForm.pin">
                                    </b-form-input>
                                    <i class="ri-eye-close-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="showPin = true"
                                       v-if="!showPin"></i>
                                    <i class="ri-eye-2-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="showPin = false"
                                       v-if="showPin"></i>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12">
                            <b-button @click="login" block variant="primary">{{ $t('login').toUpper() }}</b-button>
                        </div>
                        <div class="col-12">
                            <b-button @click="$router.push('/visitor-student/application/register')" block variant="link">{{ $t('sign_up').toUpper() }}</b-button>
                        </div>
                        <div class="d-flex justify-content-center mb-4">
                            <b-button variant="outline-secondary" block @click="$router.push('/visitor-student/application/forgot/password')">
                                {{ $t('forgot_my_password') }}
                            </b-button>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </GuestStudentLayout>
    </div>
</template>
<script>
import VisitorStudentApplicationServices from "@/services/VisitorStudentApplicationServices";
import GuestStudentLayout from "@/modules/visitorStudentApplication/student/layouts/GuestStudentLayout.vue";

export default {
    name: "Login",
    components: {
        GuestStudentLayout,
    },
    metaInfo() {
        return {
            title: this.$t('guest_student_application_system')
        }
    },
    data() {
        return {
            loginForm: {
                national_id: null,
                passport_number: null,
                pin: null,
            },
            showPin: false,
        }
    },
    created() {
        if (this.$store.getters['VisitorStudentApplicationStore/isLoggedIn']) {
            this.$store.dispatch('VisitorStudentApplicationStore/logout');
        }
    },
    methods: {
        async login() {
            const isValid = await this.$refs.loginForm.validate();
            if (!isValid) return;

            try {
                const data = { pin: this.loginForm.pin }
                if (this.loginForm.national_id) {
                    data.national_id = this.loginForm.national_id
                } else {
                    data.passport_number = this.loginForm.passport_number
                }

                const res = await VisitorStudentApplicationServices.login(data)

                const userData = {
                    national_id: this.loginForm.national_id || null,
                    passport_number: this.loginForm.passport_number || null,
                    ...res.data.data
                }

                await this.$store.dispatch('VisitorStudentApplicationStore/setVisitorApplicationUser', userData)
                await this.$store.dispatch('VisitorStudentApplicationStore/setPin', this.loginForm.pin)

                try {
                    const params = { pin: this.loginForm.pin };
                    if (this.loginForm.national_id) {
                        params.national_id = this.loginForm.national_id;
                    } else {
                        params.passport_number = this.loginForm.passport_number;
                    }
                    const continueRes = await VisitorStudentApplicationServices.continueApplication({ params });
                    const continueData = continueRes.data?.data;
                    if (continueData && Object.keys(continueData).length > 0) {
                        await this.$store.dispatch('VisitorStudentApplicationStore/setApplicationData', continueData);
                    }
                } catch (_) {
                    // continue-application
                }

                this.$router.push('/visitor-student/application/form')
            } catch (e) {
                this.showErrors(e, this.$refs.loginForm)
            }
        },
    },
};
</script>
